import React from 'react';
import Box from '@mui/material/Box';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import AlertComponent from '@ui/components/Alert/Alert.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    alert,
    alertText,
    children,
    className,
    lang,
    loading,
    loadold,
    title,
    text,
    onBtnKeyDown,
    onBackClick,
    onClose,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <Box
            className={'modal' + (className ? ` ${className}` : '')}
            component="section"
        >
            {!loadold && <IconButton
                className="close-btn"
                onClick={onClose}
                onKeyDown={onBtnKeyDown}
            >
                <CloseIcon className="close-btn__ico" />
            </IconButton>}
            {!loading &&!loadold && (
                <>
                    {onBackClick && (
                        <IconButton className="back-btn" onClick={onBackClick}>
                            <ArrowBackIcon />
                        </IconButton>
                    )}
                    <Typography
                        className={
                            text ? 'modal__title_with-text' : 'modal__title'
                        }
                        variant="h6"
                    >
                        {getWord(title)}
                    </Typography>
                    {text && (
                        <Typography className="modal__text" variant="body1">
                            {getWord(text)}
                        </Typography>
                    )}
                    <AlertComponent
                        variant="modal"
                        severity={alert}
                        lang={lang}
                        message={alertText}
                        display={!!alertText}
                    />
                    {children}
                </>
            )}
            {loading && (
                <Box className="modal__loader">
                    <CircularProgress size={50} />
                </Box>
            )}
            {loadold && (
                <Box className="modal__loader">
                    <CircularProgress color="secondary" size={50} />
                </Box>
            )}
        </Box>
    );
};

const ModalComponent = React.memo(Component);

export default ModalComponent;
